import React, { useEffect, useState } from "react";
import { Button } from "../../../../../../shadcn/components/ui/button";
import { useSelector } from "react-redux";
import {
  getBidderByUuid,
  getDigioESignStatusForJoint,
  initiateConsentNotificationForPrimary,
  initiateDigioESignForJoint,
  updateBidderForEvent,
} from "services/bidder";
import SwitchToOfflineKycModal from "../../SwitchToOfflineKycModal";
import CustomLoadingModal from "../IndividualBidders/CustomLoadingModal";
import SwitchToOtherKYCModeNotification from "../SwitchToOtherKYCModeNotification";
import KycStatusNotice from "../KycStatusNotice";
interface JBESignComponentProps {
  bidderUuid: any;
  bidder: any;
  stepsTitles: any;
  activeStep: any;
  setActiveStep: any;
  init: any;
}

export default function JBESignComponent({
  bidderUuid,
  init,
  activeStep,
  setActiveStep,
}: JBESignComponentProps) {
  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });
  const [checkingStatus, setCheckingStatus] = useState<any>(false);
  const [requestingStatus, setRequestingStatus] = useState<any>(false);
  const [isNavigated, setIsNavigated] = useState<any>(false);
  const [isSignPending, setIsSignPending] = useState<any>(false);
  const [switchToOfflineModalOpen, setSwitchToOfflineModalOpen] =
    useState(false);
  const [switchingToOffline, setSwitchingToOffline] = useState(false);
  const [isOnlineModeIssue, setIsOnlineModeIssue] = useState(false);
  const [error, setError] = useState<any>("");
  const [initialStatusCheckDone, setInitialStatusCheckDone] = useState(false);
  const handleBannerSwitch = async () => {
    setSwitchToOfflineModalOpen(true);
  };
  useEffect(() => {
    const scriptId = "digio-sdk-script";

    // Check if script is already added
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.type = "text/javascript";
      script.src = "https://app.digio.in/sdk/v11/digio.js";
      script.async = true;

      document.body.appendChild(script);
      console.log("SCRIPT__INJECTED");

      // Cleanup function
      return () => {
        const existingScript = document.getElementById(scriptId);
        if (existingScript) {
          console.log("called");
          document.body.removeChild(existingScript);
        }
      };
    }
  }, [checkingStatus]);

  const handleRequestSigning = async () => {
    setRequestingStatus(true);
    try {
      setError("");
      const res: any = await initiateDigioESignForJoint({
        bidder_onboarding_uuid: onboardingData.uuid,
        eligible_bidders_uuid: bidderUuid,
      });
      setIsNavigated(true);
      console.log("res:------ ", res, res.data.id);
      var options = {
        environment: process?.env?.NEXT_PUBLIC_DIGIO_ENVIRONMENT,
        callback: async function (response: any) {
          if (response.hasOwnProperty("error_code")) {
            //check status of flow
            console.log("response---------->>>>", response);
            // return console.log("error occurred in process");
          }
          console.log("response---------->>>>", response);
          //check status of flow
          console.log("Signing;completed;successfully:");
          await init();
          setIsNavigated(false);
        },
        logo: process.env.NEXT_PUBLIC_IMAGIX_URL?.includes("staging")
          ? `${process.env.NEXT_PUBLIC_IMAGIX_URL}/24534319-e399-47f9-ad4c-f98d5d9bbbb3`
          : `${process.env.NEXT_PUBLIC_IMAGIX_URL}/fa4a3024-6d97-488b-88e0-a6f5d802b2ba`,
        is_redirection_approach: false,
        is_iframe: true,
        theme: {
          primaryColor: "#FF752C",
          secondaryColor: "#262626",
        },
      };
      // @ts-ignore
      var digio = new Digio(options);
      digio.init();
      digio.submit(
        res.data.id,
        onboardingData?.mobile,
        res.data?.access_token?.id,
      );
      setIsNavigated(true);
    } catch (error) {
      console.log("error:====>>> ", error);
      setError(
        "Oops! Something went wrong. Please try again in a few moments.",
      );
    }
    setRequestingStatus(false);
  };

  useEffect(() => {
    (async () => {
      try {
        console.log("called=======>>>>1");
        await new Promise((resolve) => setTimeout(resolve, 1000));
        const data: any = await getBidderByUuid(bidderUuid);
        if (data?.esigned_data?.request_id) {
          setCheckingStatus(true);
          const payload = {
            eligible_bidders_uuid: bidderUuid,
            e_sign_request_id: data?.esigned_data?.request_id,
          };
          const res: any = await getDigioESignStatusForJoint(payload);
          console.log("res:======>>>> ", res);
          if (
            res?.data?.agreement_status === "completed" &&
            data?.verification_step !== "wait_for_consent"
          ) {
            const data: any = await getBidderByUuid(bidderUuid);
            const bidderRelations = data?.bidder_relations || [];
            const consentData = [];
            for (const bidderData of bidderRelations) {
              if (bidderUuid !== bidderData?.bidder_uuid) {
                const viewerData: any = await getBidderByUuid(
                  bidderData?.bidder_uuid,
                );
                consentData.push({
                  bidder_uuid: bidderData?.bidder_uuid,
                  primary_bidder_uuid: bidderData?.primary_bidder_uuid,
                  consent_status:
                    viewerData?.status === "verified" ? "approved" : "pending",
                });
              } else {
                consentData.push({
                  bidder_uuid: bidderData?.bidder_uuid,
                  primary_bidder_uuid: bidderData?.primary_bidder_uuid,
                  consent_status:
                    bidderData.type === "primary" ? "approved" : "pending",
                });
              }
            }
            console.log("consentData: ", consentData);

            if (data?.esigned_data?.consent_notified !== true) {
              // sent consent emails to joint bidders
              try {
                await initiateConsentNotificationForPrimary({
                  eligible_bidders_uuid: bidderUuid,
                });
              } catch (error) {
                console.log("consent notification error: ", error);
              }
            }
            const updateData: any = {
              uuid: bidderUuid,
              meta: {
                ...data?.meta,
                submission_time: new Date().toISOString(),
                steps_status: {
                  ...data?.meta?.steps_status,
                  e_sign: "completed",
                },
              },
              esigned_data: {
                ...data?.esigned_data,
                e_signed_response: res?.data,
                consent_data: consentData,
                consent_notified: true,
              },
              verification_step: "wait_for_consent",
            };
            if (data?.remarks) {
              updateData.remarks = "KYC updated";
            }
            if (data?.status === "rejected") {
              updateData.status = "pending";
            }
            await updateBidderForEvent(updateData);

            setActiveStep(activeStep + 1);
            await new Promise((resolve) => setTimeout(resolve, 1000));
            await init();
            setIsSignPending(false);
          } else if (
            res?.data?.agreement_status === "completed" &&
            data?.verification_step === "wait_for_consent"
          ) {
            setActiveStep(activeStep + 1);
            await new Promise((resolve) => setTimeout(resolve, 1000));
            await init();
            setIsSignPending(false);
          } else {
            setIsSignPending(true);
            setIsOnlineModeIssue(true);
          }
          setCheckingStatus(false);
          setInitialStatusCheckDone(true);
        }
      } catch (error) {
        console.log("error: ", error);
        setCheckingStatus(false);
        setInitialStatusCheckDone(true);
      }
    })();
  }, [isNavigated]);
  const handleSwitchToOffline = async () => {
    if (switchingToOffline) return;

    setSwitchingToOffline(true);
    setSwitchToOfflineModalOpen(false);
    try {
      const data: any = await getBidderByUuid(bidderUuid);
      await updateBidderForEvent({
        uuid: bidderUuid,
        meta: {
          ...data?.meta,
          bid_application_flow_mode: "offline",
        },
      });
      // Reload the page to show offline KYC flow
      window.location.reload();
    } catch (error) {
      console.log("error switching to offline KYC: ", error);
      setSwitchingToOffline(false);
    }
  };
  const isJointIndividualOfflineFlowEnabled =
    process.env.NEXT_PUBLIC_ENABLE_OFFLINE_JOINT_INDIVIDUALS_KYC === "true";
  return (
    <div className="py-4 bg-white rounded-lg mt-6">
      <p className="text-lg font-semibold text-gray-700">
        You need to complete E-sign to participate in the bidding process.
      </p>
      <div className="my-4">
        {initialStatusCheckDone && checkingStatus && (
          <KycStatusNotice
            variant="info"
            message="Checking your KYC status. Please wait..."
          />
        )}
        {initialStatusCheckDone && isSignPending && !checkingStatus && (
          <KycStatusNotice
            variant="warning"
            message="Your E-sign process is incomplete. Please complete all required steps to proceed."
          />
        )}
        {isJointIndividualOfflineFlowEnabled &&
          initialStatusCheckDone &&
          isOnlineModeIssue && (
            <SwitchToOtherKYCModeNotification
              handleSwitch={handleBannerSwitch}
              switchingToModes={switchingToOffline}
              switchMode="Offline"
            />
          )}
      </div>
      <p className="text-sm text-gray-600 mt-2">
        This secure digital signature process is powered by Digio and ensures
        that all your submitted documents are legally compliant and verifiable.
        Make sure your Aadhaar-linked mobile number is active to receive the OTP
        during signing.
      </p>
      <div className="mt-16 mb-10 md:mb-0">
        {error && <div className="text-sm text-brand-textRed">{error}</div>}
        <Button
          className="w-full max-w-xl h-10 text-lg"
          onClick={handleRequestSigning}
          disabled={checkingStatus || error}
        >
          Proceed
        </Button>
      </div>
      {requestingStatus && (
        <CustomLoadingModal
          loadingText="Preparing your e-sign process… please hold on for a moment."
          spinnerSize={48}
          overlayOpacity="50"
        />
      )}
      {switchToOfflineModalOpen && (
        <SwitchToOfflineKycModal
          open={switchToOfflineModalOpen}
          setOpen={setSwitchToOfflineModalOpen}
          handleConfirm={handleSwitchToOffline}
        />
      )}
    </div>
  );
}
